import { apis } from 'ui-common'
import endpoints from 'ui-common/lib/constants/endpoints.json'

export default {
  getProfile: () => apis.$get(endpoints.users.current)
}
